import src from "IMAGE";
export default { src, width: 1032, height: 246, blurWidth: 0, blurHeight: 0};
